import { render, staticRenderFns } from "./AiChatH5.vue?vue&type=template&id=a9a79554&scoped=true"
import script from "./AiChatH5.vue?vue&type=script&lang=js"
export * from "./AiChatH5.vue?vue&type=script&lang=js"
import style0 from "./AiChatH5.vue?vue&type=style&index=0&id=a9a79554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a79554",
  null
  
)

export default component.exports